<div>
  <div *ngFor="let tableSection of tableSections" class="CommonTable">
    <div id="{{ tableSection.heading }}" [innerHTML]="tableSection.body | mdToHtml"></div>
    <div class="body-table AutoWidthTable" *ngIf="tableSection.table && !ocnTable" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
    <div class="body-table" *ngIf="tableSection.table && ocnTable" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
  </div>
</div>
